import { type AuthOptions, createAuthLink } from 'aws-appsync-auth-link'
import { ApolloClient, HttpLink } from 'apollo-boost'
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link'
import { getJwtToken, appSyncConfig, Auth, getIsAuthenticated } from '@edge/spark/io-aws'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { ApolloLink } from 'apollo-link'
import { createDialog } from '@edge/spark/feature-dialog'

const url = appSyncConfig.aws_appsync_graphqlEndpoint || ''

if (!url) {
    console.error('Missing aws_appsync_graphqlEndpoint')
}

const region = appSyncConfig.aws_appsync_region
const auth = {
    type: appSyncConfig.aws_appsync_authenticationType,
    jwtToken: async () => {
        try {
            const isAuthed = await getIsAuthenticated()

            if (!isAuthed) {
                return ''
            }

            const token = await getJwtToken()
            if (!token) {
                console.error('apollo client isAuthenticated but no token. Signout?')

                createDialog({
                    message: 'You have been signed out. Please sign in again.',
                    action: 'LOGOUT',
                    timeout: 5_000,
                })

                return ''
            }

            return token
        } catch (e) {
            console.error('apollo client error. Signing out...', e)
            await Auth.signOut()
            return ''
        }
    },

    // aws_appsync_authenticationType is union type
} as AuthOptions
const httpLink = new HttpLink({ uri: url })
const authLink = createAuthLink({ url, region, auth })
const subscriptionLink = createSubscriptionHandshakeLink({ url, region, auth })
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore still an issue?
const link = ApolloLink.from([authLink, subscriptionLink])
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore graphql peer version mismatch (graphql@16 vs apollo-cache-inmemory@1.x)
export const clientSingleton = new ApolloClient({ link, cache: new InMemoryCache() })
export type Client = ApolloClient<any>

export const mockedClient = new ApolloClient({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore graphql peer version mismatch (graphql@16 vs apollo-cache-inmemory@1.x)
    cache: new InMemoryCache(),
    link: new HttpLink({ uri: '/graphql' }),
    resolvers: {
        Query: {
            activeOrganization: () => ({
                __typename: 'Organization',
                orgId: 'foo',
            }),
        },
    },
})
